import { render, staticRenderFns } from "./_point.vue?vue&type=template&id=9f2e538e&"
import script from "./_point.vue?vue&type=script&lang=js&"
export * from "./_point.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports